//src/Components/SideBarNav/UnreadMessagesCount.tsx
import { useNotificationsCounter } from 'app/features/notifications/NotificationsCounterProvider';
import Spinner from 'Components/Spinner';

export default function UnreadMessagesCount() {
  const counter = useNotificationsCounter();

  if (!counter) return <Spinner bounce={false} />;
  if (counter.unread_messages_count === 0) return null;

  return (
    <div className="text-green-light bg-green rounded-full flex justify-center items-center w-6 h-5 text-xs">
      {counter.unread_messages_count > 9 ? '9+' : counter.unread_messages_count}
    </div>
  );
}
